export interface TSideBarState {
  name: string;
}

enum ActionTypes {
  SET_SIDEBAR = '@@sidebar/SET_SIDEBAR',
}

export default ActionTypes;
